import React from "react";
import {
  HealthDot,
  Item,
  LastSync,
  Name,
  NameRow,
} from "./InstanceListItem.styles";
import type { InstanceListItemProps } from "./InstanceListItem.types";

/**
 * Instance-sidebar list row used by the connector detail page (UI-4).
 * Stateless — selection is owned by the parent (the page or sidebar
 * organism). Renders a left blue accent border + light-blue tint when
 * `selected` to mirror Figma's active-state, and an optional health dot
 * (green/amber/red) before the name when `health` is provided.
 */
export const InstanceListItem: React.FC<InstanceListItemProps> = ({
  name,
  lastSyncLabel,
  selected,
  onClick,
  health,
  className,
}) => (
  <Item
    type="button"
    $selected={selected}
    onClick={onClick}
    aria-current={selected ? "true" : undefined}
    className={className}
  >
    <NameRow>
      {health ? <HealthDot $health={health} aria-hidden /> : null}
      <Name>{name}</Name>
    </NameRow>
    <LastSync>{lastSyncLabel}</LastSync>
  </Item>
);

export default InstanceListItem;
